export default __webpack_public_path__ + "static/media/ContactRemove.8aa0c4ac.svg";